export function getPaginationRange(numberOfPages, currentPage, totalDisplayed) {
  const adjacentCount = (totalDisplayed - 1) / 2;
  const pagination = [];

  pagination.push(1);

  if (currentPage > totalDisplayed - 1) {
    pagination.push('...');
  }

  const start = Math.max(2, currentPage - adjacentCount);
  const end = Math.min(numberOfPages - 1, currentPage + adjacentCount);

  for (let i = start; i <= end; i++) {
    pagination.push(i);
  }

  if (currentPage < numberOfPages - adjacentCount - 1) {
    pagination.push('...');
  }

  if (numberOfPages > 1) {
    pagination.push(numberOfPages);
  }

  return pagination;
}
